import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://adalardatatil.com";

export default function Seo({ title, description, image, type = "website", noindex = false, breadcrumb, path }) {
  const { pathname } = useLocation();
  const canonical = SITE + (path || pathname);
  const fullTitle = title ? `${title} · Adalarda Tatil` : "Adalarda Tatil | Yunan Adaları Feribot, Otel ve Turlar";
  const desc = description || "Türkiye'den Yunan Adaları'na — feribot bileti, otel, tur, araç kiralama ve vize. En iyi fiyat garantisi.";
  const og = image || `${SITE}/og-default.jpg`;

  const breadcrumbJsonLd = breadcrumb && breadcrumb.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumb.map((b, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": b.name,
      "item": SITE + b.path,
    })),
  } : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={og} />
      <meta property="og:site_name" content="Adalardatatil" />
      <meta property="og:locale" content="tr_TR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={og} />

      {breadcrumbJsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbJsonLd)}
        </script>
      )}
    </Helmet>
  );
}
